import { api } from '../api/client';
import { getYoutubeVideoId } from './youtube';
import { writeCachedHeroVideoId } from './heroVideoCache';
import { HERO_YOUTUBE_URL } from '../constants';

/** Load hero video id before first paint so StrictMode remounts stay stable. */
export async function preloadHeroVideo() {
  const envId = getYoutubeVideoId(HERO_YOUTUBE_URL);
  if (envId) {
    writeCachedHeroVideoId(envId);
  }

  try {
    const data = await api.getHeroVideo();
    const id = data?.videoId || getYoutubeVideoId(data?.youtubeUrl);
    if (id) {
      writeCachedHeroVideoId(id);
    }
  } catch {
    /* keep env/cache fallback */
  }
}
